import { PRODUCTION, STAGING, DEVELOPMENT } from "badlands-shared/constants";

export const useEnvironment = () => {
  const getEnvironment = () => {
    const host = window.location.hostname;

    if (host.includes(".dev.")) return DEVELOPMENT;
    else if (host.includes(".staging.")) return STAGING;
    else if (process.env.NODE_ENV === PRODUCTION) return PRODUCTION;
    else return DEVELOPMENT;
  };

  const isProduction = getEnvironment() === PRODUCTION;

  return { isProduction, getEnvironment };
};
